// extracted by mini-css-extract-plugin
export default {"logo":"LjSNd"};